import {
  GET_TRIPS,
  GET_ALL_TRIPS,
  TRIP_ERROR,
  UPDATE_LIKES,
  DELETE_TRIP,
  ADD_TRIP,
  GET_TRIP,
  ADD_BID,
  REMOVE_BID
} from '../actions/types';

const initialState = {
  trips: [],
  trip: null,
  loading: true,
  error: {}
};

function tripReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TRIPS:
      return {
        ...state,
        trips: payload,
        loading: false
      };
    case GET_ALL_TRIPS:
      return {
        ...state,
        trips: payload,
        loading: false
      };
    case GET_TRIP:
      return {
        ...state,
        trip: payload,
        loading: false
      };
    case ADD_TRIP:
      return {
        ...state,
        trips: [payload, ...state.trips],
        loading: false
      };
    case DELETE_TRIP:
      return {
        ...state,
        trips: state.trips.filter((trip) => trip._id !== payload),
        loading: false
      };
    case TRIP_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    case UPDATE_LIKES:
      return {
        ...state,
        trips: state.trips.map((trip) =>
          trip._id === payload.id ? { ...trip, likes: payload.likes } : trip
        ),
        loading: false
      };
    case ADD_BID:
      return {
        ...state,
        trip: { ...state.trip, bids: payload },
        loading: false
      };
    case REMOVE_BID:
      return {
        ...state,
        trip: {
          ...state.trip,
          bids: state.trip.bids.filter(
            (bid) => bid._id !== payload
          )
        },
        loading: false
      };
    default:
      return state;
  }
}

export default tripReducer;
